export const ICONS = [
  'folder_open',
  'mdi-cube-outline',
  'public',
  'extension',
  'science',
  'bug_report',
  'bolt',
  'call_merge',
  'commit',
  'mdi-source-branch',
  'traffic',
  'mdi-clipboard-check-outline',
  'mdi-progress-clock',
  'visibility',
  'vpn_key',
  'lightbulb',
  'favorite',
  'star',
  'auto_awesome',
  'mdi-controller-classic',
  'precision_manufacturing',
  'tour',
  'podcasts',
  'inventory',
  'save',
  'security',
  'mdi-lifebuoy',
  'mdi-ab-testing',
  'mdi-api',
  'mdi-console',
  'mdi-database',
  'mdi-vpn',
  'mdi-server',
  'mdi-server-security',
  'mdi-network-outline',
  'mdi-lan',
  'mdi-nas',
  'mdi-ansible',
  'mdi-aws',
  'mdi-microsoft-azure',
  'mdi-google-cloud',
  'mdi-kubernetes',
  'mdi-terraform',
]

export const ENV_PRESETS = [
  {
    name: 'dev',
    background: '#C6D2E3',
    foreground: '#3B4F6B',
    icon: 'commit',
  },
  {
    name: 'prod',
    background: '#A4D5D5',
    foreground: '#115B5B',
    icon: 'public',
  },
  {
    name: 'demo',
    background: '#A4D5D5',
    foreground: '#115B5B',
    icon: 'auto_awesome',
  },
  {
    name: 'success',
    background: '#97CF8F',
    foreground: '#316929',
    icon: 'lightbulb',
  },
  {
    name: 'default',
    background: '#BBA6A8',
    foreground: '#582026',
    icon: 'extension',
  },
  {
    name: 'error',
    background: '#F07A8A',
    foreground: '#5C0D18',
    icon: 'bug_report',
  },
  {
    name: 'staging',
    background: '#F6B967',
    foreground: '#905301',
    icon: 'science',
  },
  {
    name: 'preprod',
    background: '#F6B967',
    foreground: '#905301',
    icon: 'traffic',
  },
]

export const DEFAULT_COLOR_NAME = 'dev'
export const DEFAULT_COLOR = '#C6D2E3'
export const DEFAULT_ICON = 'folder_open'
export const DEFAULT_ICON_COLOR = '#3B4F6B'
